import Chart from 'react-apexcharts'
import {ApexOptions} from 'apexcharts'
import {getDateForChart} from 'src/feature/bite/helpers/date'
import Spinner from 'react-bootstrap/esm/Spinner'

export default function LineChart({
  data: {series, categories},
}: {
  data: {
    series: {name: string; data: number[]}[]
    categories: string[]
  }
}) {
  const options: ApexOptions = {
    colors: ['#ED7B40', '#141413'],

    chart: {
      type: 'line',
      zoom: {
        enabled: false,
      },
    },
    // toolbar: {
    //   show: true,
    //   tools: {
    //     download: false,
    //   },
    // },
    // export: {
    //   enabled: false,
    // },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'straight',
      colors: ['#1e293b'],
    },
    grid: {
      show: false,
      padding: {
        left: 30,
        right: 50,
        bottom: 10,
        top: 10,
      },
    },
    xaxis: {
      // type: 'datetime',
      type: 'category',
      tickPlacement: 'between',
      tickAmount: 'dataPoints',
      labels: {
        formatter: (value: string) => {
          return getDateForChart(value)
        },
        // offsetY: 5,
      },
      tooltip: {
        enabled: false,
      },
      categories,
    },
    markers: {
      size: 0,
      colors: ['#ED7B40'],
      strokeColors: '#fff',
      strokeWidth: 2,
      hover: {
        size: 6,
        sizeOffset: 3,
      },
    },
    yaxis: {
      show: false,
    },
  }

  if (series[0].data.length === 0) {
    return (
      <div style={{height: 300, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <Spinner animation='border' />
      </div>
    )
  }

  return (
    <>
      <Chart options={options} series={series} type='line' height={350} />
    </>
  )
}
